import MasterCrudPage from "../../components/MasterCrudPage";
import {
  mediaTypeApi,
  userMasterApi,
  userNewsMediaApi,
} from "../../api/masterApi";

function userLabel(user) {
  const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
  return name || "User";
}

export default function UserNewsMedia() {
  return (
    <MasterCrudPage
      title="News & Media"
      description="User news and media entries with images and YouTube video URLs."
      idKey="media_id"
      api={userNewsMediaApi}
      listLabel="news & media"
      scopeToCurrentUser
      loadExtraOptions={async () => {
        const [users, mediaTypes] = await Promise.all([
          userMasterApi.list(),
          mediaTypeApi.list(),
        ]);
        return {
          users: (users || []).map((user) => ({
            value: user.user_id,
            label: userLabel(user),
          })),
          mediaTypes: (mediaTypes || []).map((type) => ({
            value: type.media_type_id,
            label: type.media_type_name,
          })),
        };
      }}
      fields={[
        {
          name: "user_id",
          label: "User",
          type: "select",
          required: true,
          optionsKey: "users",
          placeholder: "Select user",
        },
        {
          name: "media_type_id",
          label: "Media Type",
          type: "select",
          required: true,
          optionsKey: "mediaTypes",
          placeholder: "Select media type",
        },
        {
          name: "media_images",
          label: "Upload Images",
          type: "files",
          hint: "Select one or more images",
          fullWidth: true,
        },
        {
          name: "video_urls",
          label: "Video URLs (YouTube only)",
          type: "stringlist",
          fullWidth: true,
          placeholder: "One YouTube URL per line",
          hint: "Enter YouTube URLs only, one per line",
        },
        {
          name: "publication_date",
          label: "Publication Date",
          type: "date",
        },
        {
          name: "publication_platform",
          label: "Publication Platform",
          type: "text",
          placeholder: "e.g. Times of India, YouTube",
        },
        {
          name: "description",
          label: "Description",
          type: "textarea",
          fullWidth: true,
          placeholder: "Short description",
        },
      ]}
      columns={[
        { key: "media_id", label: "Media" },
        {
          key: "user_id",
          label: "User",
          render: (item) =>
            [item.user_id, item.first_name, item.last_name].filter(Boolean).join(" ") || "—",
        },
        { key: "media_type_name", label: "Media Type" },
        { key: "media_images", label: "Images", type: "images" },
        {
          key: "video_urls",
          label: "Video URLs",
          render: (item) =>
            Array.isArray(item.video_urls) && item.video_urls.length
              ? item.video_urls.join(", ")
              : "—",
        },
        { key: "publication_date", label: "Publication Date" },
        { key: "publication_platform", label: "Platform" },
      ]}
    />
  );
}
